import { msg } from '@lingui/core/macro'
import { defineEnum } from '@pkg/shared/utils/enum-builder'
import {
  FaDroplet,
  FaGlassWater,
  FaPills,
  FaPlug,
  FaSyringe,
  FaThermometer,
  FaUtensils,
  FaWater,
} from 'react-icons/fa6'

export const TherapyTypeEnum = defineEnum({
  Antibiosis: { label: msg`Antibiose`, icon: FaPills },
  Dialysis: { label: msg`Dialyse`, icon: FaDroplet },
  EnteralLiquidFood: { label: msg`Enteral-Trinknahrung`, icon: FaUtensils },
  EnteralTubeFeeding: { label: msg`Enteral-Sondenkost`, icon: FaUtensils },
  FluidReplacement: { label: msg`Flüssigkeitssubstitution`, icon: FaGlassWater },
  Heimparenteral: { label: msg`Heimparenteral`, icon: FaSyringe },
  Immunoglobulin: { label: msg`Immunglobulin-Therapie`, icon: FaSyringe },
  IVAccess: { label: msg`Verbandswechsel-IV-Zugang`, icon: FaSyringe },
  PainTherapy: { label: msg`Schmerztherapie`, icon: FaThermometer },
  PortFlushing: { label: msg`Portspülung`, icon: FaWater },
  PowerPiccSupply: { label: msg`Power-PICC-Versorgung`, icon: FaPlug },
})

export type TherapyType = typeof TherapyTypeEnum.$.Type
